import { createContext, use } from 'react'

type AstraSideNavContextType = {
    isOpen: boolean
}

export const AstraSideNavContext = createContext<AstraSideNavContextType | null>(null)

export const useSidenavContext = () => {
    const context = use(AstraSideNavContext)

    if (!context) {
        throw new Error('useSidenavContext must be used within a AstraSideNavProvider')
    }

    return context.isOpen
}
